import { render, staticRenderFns } from "./hqStuHealthKnowledgeShow.vue?vue&type=template&id=90f3c1d4&scoped=true"
import script from "./hqStuHealthKnowledgeShow.vue?vue&type=script&lang=js"
export * from "./hqStuHealthKnowledgeShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90f3c1d4",
  null
  
)

export default component.exports